"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("../actions/types");
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var removeEmptyKeys = function removeEmptyKeys(partner) {
  Object.keys(partner).forEach(function (key) {
    return partner[key] === '' && delete partner[key];
  });
};
var initialState = {};
var partnersReducer = function partnersReducer() {
  var _partners$, _partners$2;
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var _action$value = action.value,
    value = _action$value === void 0 ? {} : _action$value,
    type = action.type;
  var _value$partners = value.partners,
    partners = _value$partners === void 0 ? [] : _value$partners;
  switch (type) {
    case _types.LOAD_CHAT_DONE:
    case _types.LOAD_CHAT_ERROR:
    case _types.JOIN_ROOM_DONE:
    case _types.RECEIVE_CHATS:
    case _types.UPDATE_PARTNERS:
      return _objectSpread({}, _updatePartners(partners, state));
    case _types.UPDATE_PARTNERS_BLOCKED:
      var filteredPartners = _getPartners((_partners$ = partners[0]) === null || _partners$ === void 0 ? void 0 : _partners$.id, (_partners$2 = partners[0]) === null || _partners$2 === void 0 ? void 0 : _partners$2.status, state);
      return _objectSpread({}, _updatePartners(filteredPartners, state));
    default:
      return state;
  }
};
var _getPartners = function _getPartners(id, status, state) {
  return Object.values(state).filter(function (partner) {
    return partner.id === id;
  }).map(function (partner) {
    partner.status = status;
    return partner;
  });
};
var _updatePartners = function _updatePartners() {
  var partners = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var state = arguments.length > 1 ? arguments[1] : undefined;
  var acc = {};
  partners.forEach(function (partner) {
    var roomname = partner.roomname;
    if (roomname) {
      var _acc$roomname;
      acc[roomname] = _objectSpread(_objectSpread({}, _updatePartner(partner, state[roomname])), {}, {
        hasActiveAd: ((_acc$roomname = acc[roomname]) === null || _acc$roomname === void 0 ? void 0 : _acc$roomname.hasActiveAd) || partner.adStatus === 'active'
      });
    }
  });
  return _objectSpread(_objectSpread({}, state), acc);
};
var _updatePartner = function _updatePartner(partner, state) {
  removeEmptyKeys(partner);
  return _objectSpread(_objectSpread({}, state), partner);
};
var _default = exports["default"] = partnersReducer;